module.exports = __webpack_public_path__ + "img/yagang.bef3c6d5.png";